export default __webpack_public_path__ + "static/media/Foto9.4ec0590d.png";